import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";

export function createOutboundApi() {
  const apiUrlTest = "/gateway/edi/product/query"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.outboundorderapiDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [
        [
          {
            key: "apiDocDesc.testUrl",
            value:
              "https://demo-sop.jtfulfillment.cn/gateway/edi/stockOutOrder/create"
          },
          {
            key: "apiDocDesc.proUrl",
            value:
              "https://sop.jtfulfillment.cn/gateway/edi/stockOutOrder/create"
          },
          { key: "customerid:", value: "CS001" },
          { key: "warehouseCode:", value: "SH.001" },
          { key: "itemCode:", value: "YL001" },
          { key: "eccompanyid:", value: "STANDARD" },
          {
            key: "KEY:",
            value: "MGY3MTU3M2M3NjYxN2RhNjc3NzM4MzM2Y2Q5ZjQ0ZWU="
          }
        ],
        [
          {
            key: "apiDocDesc.testUrlCn",
            value:
              "https://demo-openapi.jtfulfillment.cn/gateway/edi/stockOutOrder/create"
          },
          {
            key: "apiDocDesc.proUrlCn",
            value:
              "https://openapi.jtfulfillment.cn/gateway/edi/stockOutOrder/create"
          },
          { key: "customerid:", value: "UPFOS-TEST" },
          { key: "warehouseCode:", value: "SH.001" },
          { key: "itemCode:", value: "STZX0000001" },
          { key: "eccompanyid:", value: "UPFOS-TEST_PPL" },
          {
            key: "KEY:",
            value: "ZDZmNTM1NWE2ZDQ5NjU4Y2Q4YzY5YWIwZGRjZTEyMzE="
          }
        ]
      ],
      //参数描述  START
      postDataList: [
        //   请求头参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "customerid",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.customeridDesc197"
            },
            {
              name: "warehouseCode",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.warehouseCodeDesc198"
            },
            {
              name: "eccompanyid",
              type: "varchar(100)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.eccompanyidDesc199"
            },
            {
              name: "storerKey",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.storerKeyDesc200"
            },
            {
              name: "txlogisticid",
              type: "varchar(200)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.txlogisticidDesc201"
            },
            {
              name: "orderType",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.orderTypeDesc202"
            },
            {
              name: "source",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.sourceDesc203"
            },
            {
              name: "platformNumber",
              type: "varchar(200)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.platformNumberDesc204"
            },
            {
              name: "sourceSystem",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.sourceSystemDesc205"
            },
            {
              name: "outBizNo",
              type: "varchar(200)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.outBizNoDesc206"
            },
            {
              name: "payTime",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.payTimeDesc207"
            },
            {
              name: "createOrderTime",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.createOrderTimeDesc208"
            },
            {
              name: "requiredStockTime",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.requiredStockTimeDesc209"
            },
            {
              name: "businessMode",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.businessModeDesc210"
            },
            {
              name: "packageId",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.packageIdDesc1"
            },
            {
              name: "shippingProviderid",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.shippingProviderid"
            },
            {
              name: "sender",
              type: "object",
              require: "N",
              normal: "",
              describe: "apiDocDesc.senderDesc211",
              children: [
                {
                  name: "countrycode",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.countrycodeDesc212"
                },
                {
                  name: "company",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.companyDesc213"
                },
                {
                  name: "name",
                  type: "varchar(610)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.nameDesc214"
                },
                {
                  name: "postcode",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.postcodeDesc215"
                },
                {
                  name: "mailbox",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.mailboxDesc216"
                },
                {
                  name: "prov",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.provDesc217"
                },
                {
                  name: "city",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.cityDesc218"
                },
                {
                  name: "area",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.areaDesc219"
                },

                {
                  name: "address",
                  type: "varchar(800)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.addressDesc220"
                },
                {
                  name: "address2",
                  type: "varchar(500)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.address2Desc221"
                },
                {
                  name: "mobile",
                  type: "varchar(450)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.mobileDesc222"
                },
                {
                  name: "phone",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.phoneDesc223"
                }
              ]
            },
            {
              name: "receiver",
              type: "object",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.receiverDesc224",
              children: [
                {
                  name: "shipTo",
                  type: "varchar(50)",
                  require: "C",
                  normal: "",
                  describe: "apiDocDesc.shipToDesc225"
                },
                {
                  name: "supplierCode",
                  type: "varchar(64)",
                  require: "C",
                  normal: "",
                  describe: "apiDocDesc.supplierCodeDesc226"
                },
                {
                  name: "countrycode",
                  type: "varchar(50)",
                  require: "C",
                  normal: "",
                  describe: "apiDocDesc.countrycodeDesc227"
                },
                {
                  name: "shortAddress",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.addressDesc2201"
                },
                {
                  name: "address",
                  type: "varchar(800)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.addressDesc228"
                },
                {
                  name: "address2",
                  type: "varchar(500)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.address2Desc229"
                },
                {
                  name: "area",
                  type: "varchar(100)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.areaDesc230"
                },
                {
                  name: "city",
                  type: "varchar(100)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.cityDesc231"
                },
                {
                  name: "prov",
                  type: "varchar(100)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.provDesc232"
                },
                {
                  name: "postcode",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.postcodeDesc233"
                },
                {
                  name: "name",
                  type: "varchar(610)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.nameDesc234"
                },
                {
                  name: "phone",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.phoneDesc235"
                },
                {
                  name: "mobile",
                  type: "varchar(450)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.mobileDesc236"
                },
                {
                  name: "idNumber",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.idNumberDesc237"
                },
                {
                  name: "doorNo",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.doorNoDesc238"
                },
                {
                  name: "idNumberUrl",
                  type: "varchar(255)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.idNumberUrlDesc239"
                }
              ]
            },
            {
              name: "transportMode",
              type: "int",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.transportModeDesc240"
            },
            {
              name: "carrier",
              type: "varchar(50)",
              require: "C",
              normal: "",
              describe: "apiDocDesc.carrierDesc241"
            },
            {
              name: "routeid",
              type: "varchar(50)",
              require: "C",
              normal: "",
              describe: "apiDocDesc.routeidDesc242"
            },
            {
              name: "mailno",
              type: "varchar(50)",
              require: "C",
              normal: "",
              describe: "apiDocDesc.mailnoDesc243"
            },
            {
              name: "label",
              type: "varchar(1000)",
              require: "C",
              normal: "",
              describe: "apiDocDesc.labelDesc244"
            },
            {
              name: "files",
              type: "array",
              require: "C",
              normal: "",
              describe: "apiDocDesc.filesDesc",
              children: [
                {
                  name: "fileType",
                  type: "string",
                  require: "C",
                  normal: "",
                  describe: "apiDocDesc.fileTypeDesc"
                },
                {
                  name: "fileUrl",
                  type: "string",
                  require: "C",
                  normal: "",
                  describe: "apiDocDesc.fileUrlDesc"
                }
              ]
            },
            {
              name: "remark",
              type: "varchar(500)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.remarkDesc245"
            },
            {
              name: "deliveryNote",
              type: "varchar(500)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.deliveryNoteDesc246"
            },
            {
              name: "isCod",
              type: "int",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.isCodDesc247"
            },
            {
              name: "itemsvalue",
              type: "decimal(15,4)",
              require: "C",
              normal: "",
              describe: "apiDocDesc.itemsvalueDesc248"
            },
            {
              name: "pricecurrency",
              type: "VARCHAR",
              require: "C",
              normal: "",
              describe: "apiDocDesc.pricecurrencyDesc249"
            },
            {
              name: "storeCode",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.storeCodeDesc250"
            },
            {
              name: "storeName",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.storeNameDesc251"
            },
            {
              name: "isCrossBorder",
              type: "int",
              require: "N",
              normal: "1",
              describe: "apiDocDesc.isCrossBorderDesc252"
            },
            {
              name: "isPreSale",
              type: "int",
              require: "N",
              normal: "1",
              describe: "apiDocDesc.isPreSaleDesc253"
            },
            {
              name: "reserved1",
              type: "json",
              require: "N",
              normal: "",
              describe: "apiDocDesc.reserved1Desc252"
            },
            {
              name: "documentIdentification",
              type: "int",
              require: "N",
              normal: "",
              describe: "apiDocDesc.documentIdentificationDesc252"
            },
            {
              name: "items",
              type: "array",
              require: "",
              normal: "",
              describe: "apiDocDesc.itemsDesc253",
              children: [
                {
                  name: "lineNo",
                  type: "int",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.lineNoDesc254"
                },
                {
                  name: "itemCode",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.itemCodeDesc255"
                },
                {
                  name: "number",
                  type: "int",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.numberDesc256"
                },
                {
                  name: "itemvalue",
                  type: "decimal(15,4)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.itemvalueDesc257"
                },
                {
                  name: "inventoryType",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.inventoryTypeDesc258"
                },
                {
                  name: "batchCode",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.batchCodeDesc259"
                },
                {
                  name: "produceCode",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.produceCodeDesc260"
                },
                {
                  name: "productDate",
                  type: "date",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.productDateDesc261"
                },
                {
                  name: "remark",
                  type: "varchar(500)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.remarkDesc262"
                },
                {
                  name: "isGift",
                  type: "int",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.isGiftDesc263"
                },
                {
                  name: "skuId ",
                  type: "int",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.skuId"
                },
                {
                  name: "platformSkuCode",
                  type: "int",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.platformSkuCodeDesc"
                },
                {
                  name: "reserved1",
                  type: "json",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.reserved1Desc264"
                },
                {
                  name: "attachmentUrl",
                  type: "string",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.attachmentUrlDesc"
                }
              ]
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "responseitems",
              type: "",
              require: "",
              normal: "",
              describe: "apiDocDesc.responseitemsDesc265",
              children: [
                {
                  name: "txlogisticid",
                  type: "",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.txlogisticidDesc266"
                },
                {
                  name: "mailno",
                  type: "",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.mailnoDesc267"
                },
                {
                  name: "billcode",
                  type: "",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.billcodeDesc268"
                },
                {
                  name: "deliveryOrderCode",
                  type: "",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.deliveryOrderCodeDesc269"
                },
                {
                  name: "success",
                  type: "",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.successDesc270"
                },
                {
                  name: "reason",
                  type: "",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.reasonDesc271"
                },
                {
                  name: "message",
                  type: "",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.messageDesc272"
                }
              ]
            }
          ]
        }
      ],
      //请求示例
      requestCode: {
        warehouseCode: "SH.001",
        customerid: "DEV-TEST",
        eccompanyid: "test",
        storerKey: "XXXXX",
        txlogisticid: "TT20230529001",
        ordertype: "XSCK",
        source: "pdd",
        platformNumber: "XXXXX",
        sourceSystem: "XXXXX",
        outBizNo: "XXXXX",
        payTime: "2023-05-29 23:11:12",
        createOrderTime: "2023-05-29 23:11:12",
        sender: {
          countrycode: "CHN",
          company: "go",
          name: "TEST",
          postcode: "223800",
          mailbox: "736579380@qq.com",
          prov: "上海",
          city: "上海",
          area: "青浦区",
          address: "E通世界101",
          address2: "E通世界102",
          mobile: " 6281836497866",
          phone: " 6281111111111"
        },
        receiver: {
          name: "客户",
          storeCode: "mendian",
          countrycode: "CHN",
          supplierCode: "gys",
          postcode: "155555",
          mobile: " 6218305244590",
          phone: " 6281276497866",
          prov: "江苏省",
          city: "南京市",
          area: "玄武区",
          address: "A通世界华新园101",
          address2: "A通世界华新园102",
          idNumber: "12364657987945646",
          idNumberUrl: "XXXXX",
          doorNo: "666"
        },
        transportMode: "ZTJ",
        carrier: "JT",
        logisticsName: "极兔",
        routeid: "PD",
        mailno: "1234564698789789",
        label: "http://xxxxxx",
        remark: "备注",
        isCod: 0,
        itemsvalue: "100.78",
        pricecurrency: "PHP",
        storeCode: "UPFOS001",
        storeName: "UPFOS001",
        weight: 2,
        totalquantity: "2",
        items: [
          {
            lineNo: 2,
            itemCode: "test-sdflfekfeww-green",
            number: 1,
            itemvalue: "5000.02",
            inventoryType: "ZP",
            batchCode: "22222",
            produceCode: "2222",
            productDate: "2021-01-01",
            isGift: "0"
          }
        ]
      },
      //返回示例
      responseCode: {
        logisticproviderid: "YL",
        responseitems: [
          {
            txlogisticid: "170574357819",
            billcode: "JS0000001331",
            deliveryOrderCode: "SO202401060001",
            success: "true",
            reason: "",
            message: ""
          }
        ]
      }
    }
  };
}
